import { DefaultRoomSettings } from '@anm/shared/types/room';
import { ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { streamSelectors } from '../../../store/modules/stream';

const useCanAddGuestDestination = (roomId?: string, isEdit?: boolean) => {
  const roomSettings = useSelector(streamSelectors.selectRoomSettings);
  const [canGuestAddDestination, setCanGuestAddDestination] = useState<boolean | undefined>(
    isEdit ? undefined : !!DefaultRoomSettings.guestsCanAddDestinations
  );

  useEffect(() => {
    if (roomId) {
      setCanGuestAddDestination(!!roomSettings?.guestsCanAddDestinations);
    }
  }, [roomId, roomSettings?.guestsCanAddDestinations]);

  const handelAddGuestDestinationChange = (_: ChangeEvent<HTMLInputElement>) => {
    setCanGuestAddDestination(!canGuestAddDestination);
  };

  return [canGuestAddDestination, handelAddGuestDestinationChange] as const;
};

export default useCanAddGuestDestination;
